module.exports = __webpack_public_path__ + "img/icon_viptb.414cfe35.png";